import { useEffect, useState } from "react";

// Efficient countdown: updates once per second, cleans up on unmount.
// Returns { days, hours, minutes, seconds, expired } toward the given ISO target.
export const useCountdown = (target) => {
  const compute = () => {
    if (!target) return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
    const diff = new Date(target).getTime() - Date.now();
    if (isNaN(diff) || diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
    const s = Math.floor(diff / 1000);
    return {
      days: Math.floor(s / 86400),
      hours: Math.floor((s % 86400) / 3600),
      minutes: Math.floor((s % 3600) / 60),
      seconds: s % 60,
      expired: false,
    };
  };

  const [time, setTime] = useState(compute);

  useEffect(() => {
    setTime(compute());
    const id = setInterval(() => setTime(compute()), 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target]);

  return time;
};

export const pad2 = (n) => String(Math.max(0, n || 0)).padStart(2, "0");
